import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { useNavigateWithParams } from "../../../hooks/useNavigateWithParams";
import { AppRoutes } from "../../../routes/AppRoutes";
import { formatDate } from "../../../helpers/formatDate";

import LogoSvg from "../../atoms/LogoSvg/LogoSvg";
import FAIL from "../../../assets/images/FAIL.svg";
import Text from "../../atoms/Text/Text";
import Title from "../../atoms/Title/Title";
import Footer from "../../templates/Footer/Footer";
import Header from "../../templates/Header/Header";
import StyledButton from "../../atoms/StyledButton/StyledButton";


const ManageSubscriptionsCancelConfirm = () => {
  const navigate = useNavigateWithParams();
  const location = useLocation();
  const { t } = useTranslation();

  const handleConfirm = () => {
    navigate(AppRoutes.MANAGE_SUBSCRIPTIONS_CANCEL_REASON, {
      state: location.state
    });
  };

  const handleGoBack = () => {
    location.state?.type === 'subscription'
      ? navigate(AppRoutes.MANAGE_SUBSCRIPTIONS_EDIT, { state: location.state })
      : navigate(AppRoutes.MANAGE_SUBSCRIPTIONS);
  };

  return (
    <>
      <Header
        headerStep={{ context: "manage" }}
        title={
          location.state?.type !== 'subscription'
            ? t("subscription:MANAGE_PAGE.EDIT_OPTION.HEADER")
            : t("subscription:MANAGE_PAGE.EDIT_SUBSCRIPTION.HEADER")
        }
        goBack={handleGoBack}
      />
      <Box className="ManageSubscriptionsCancelConfirm">
        <Box className="content">
          <LogoSvg className="Logos" src={FAIL} />
          <Title variant="h1">
            {t("subscription:MANAGE_PAGE.CANCEL_CONFIRM.GENERIC.TITLE")}
          </Title>
          {(location.state?.type === 'option' && location.state?.code === 'premium_pack') ? (
            <>
              <Text>
                {t("subscription:MANAGE_PAGE.CANCEL_CONFIRM.OPTION.PREMIUM_PACK.SUBTITLE", {
                  date: formatDate(location.state?.next_charge_at)
                })}
              </Text>
              <Box className="advantagesList">
                <Text>
                  {t("subscription:MANAGE_PAGE.ACCOUNT_OPTIONS.PREMIUM_PACK.DESCRIPTION")}
                </Text>
              </Box>
            </>
          ) : (location.state?.type === 'option' && location.state?.code === 'warranty') ? (
            <>
              <Text>
                {t("subscription:MANAGE_PAGE.CANCEL_CONFIRM.OPTION.WARRANTY.SUBTITLE", {
                  date: formatDate(location.state?.next_charge_at)
                })}
              </Text>
              <Box className="advantagesList">
                <Text>
                  {t("subscription:MANAGE_PAGE.ACCOUNT_OPTIONS.WARRANTY.DESCRIPTION")}
                </Text>
              </Box>
            </>
          ) : (
            <>
              <Text>
                {t("subscription:MANAGE_PAGE.CANCEL_CONFIRM.SUBSCRIPTION.SUBTITLE", {
                  date: formatDate(location.state?.next_charge_at)
                })}
              </Text>
              <Box className="advantagesList">
                <Text>
                  {t("subscription:MANAGE_PAGE.CANCEL_CONFIRM.SUBSCRIPTION.ADVANTAGES.DESCRIPTION")}*
                </Text>
              </Box>
            </>
          )}
          {location.state?.type !== 'option' && <Text style={{ width: '100%' }}>{t('CANCEL_SUBSCRIPTION:FIRST_SCREEN_XSXTmention')}</Text>}
        </Box>
      </Box>
      <Footer headerStep={{ context: "manage" }}>
        <Box className="buttonContainer">
          <StyledButton onClick={() => navigate(AppRoutes.MANAGE_SUBSCRIPTIONS)}>
            {t("subscription:MANAGE_PAGE.CANCEL_CONFIRM.GENERIC.BUTTON.KEEP_ADVANTAGES")}
          </StyledButton>
          <StyledButton className="white" onClick={handleConfirm}>
            {t("subscription:MANAGE_PAGE.CANCEL_CONFIRM.GENERIC.BUTTON.CONTINUE_CANCELLATION")}
          </StyledButton>
        </Box>
      </Footer>
    </>
  );
};

export default ManageSubscriptionsCancelConfirm;